import { DefaultApi } from './api'
import { PhonesData } from './types'

export const list = () =>
  DefaultApi.request<PhonesData>('/phones', { method: 'GET', withCredentials: true })

export const create = (cellphone: { number: string, ddd: string }) =>
  DefaultApi.request('/phones', { method: 'POST', data: cellphone, withCredentials: true })

export const remove = (phoneId: string) =>
  DefaultApi.request(`/phones/${phoneId}`, { method: 'DELETE', withCredentials: true })
